import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery } from '@apollo/client/react';
import { Button } from '@chakra-ui/react';
import { EmptyState } from '@src/components/chakra-ui/empty-state';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { AdvisorsQueryState } from '@src/components/sco/Advisors/shared/AdvisorsQueryState';
import { ProfileLinksEditor } from '@src/components/sco/Advisors/shared/ProfileLinksEditor';
import { advisorBookSessionHref, advisorUserProfileHref, normalizeSessionFeeWaiveCode, suggestSessionFeeWaiveCode } from '@src/components/sco/Advisors/utils/sessionFeeWaiveCode';
import { cleanErrorMessage } from '@src/components/sco/Advisors/utils/sessionFormat';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { UPSERT_ADVISOR_PROFILE } from '@src/gql/mutations/UpsertAdvisorProfile';
import { MY_ADVISOR_PROFILE } from '@src/gql/queries/MyAdvisorProfile';
import { ScoAdvisorProfile } from '@src/graphql-types';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { useMemo, useState } from 'react';
import { LuUserRound } from 'react-icons/lu';
type ProfileQueryData = {
  myAdvisorProfile?: ScoAdvisorProfile | null;
};
const ProfileLinksForm = t0 => {
  const $ = _c(35);
  const {
    profile
  } = t0;
  const {
    currentUser
  } = useCurrentUser();
  let t1;
  if ($[0] !== currentUser?.slug) {
    t1 = currentUser?.slug?.trim() || "";
    $[0] = currentUser?.slug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slug = t1;
  const expertUserId = currentUser?.userId || "";
  let t2;
  if ($[2] !== profile.sessionFeeWaiveCode || $[3] !== slug) {
    t2 = () => normalizeSessionFeeWaiveCode(profile.sessionFeeWaiveCode) || suggestSessionFeeWaiveCode(slug);
    $[2] = profile.sessionFeeWaiveCode;
    $[3] = slug;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [waiveCode, setWaiveCode] = useState(t2);
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      refetchQueries: [{
        query: MY_ADVISOR_PROFILE
      }]
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const [upsert, upsertState] = useMutation(UPSERT_ADVISOR_PROFILE, t3);
  let t4;
  if ($[6] !== waiveCode) {
    t4 = normalizeSessionFeeWaiveCode(waiveCode);
    $[6] = waiveCode;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const normalized = t4;
  let t5;
  if ($[8] !== normalized || $[9] !== waiveCode) {
    t5 = waiveCode.trim() !== "" && !normalized;
    $[8] = normalized;
    $[9] = waiveCode;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const waiveInvalid = t5;
  const memberKey = slug || expertUserId;
  let t6;
  if ($[11] !== slug) {
    t6 = slug ? advisorUserProfileHref(slug) : null;
    $[11] = slug;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const profileUrl = t6;
  let t7;
  if ($[13] !== memberKey) {
    t7 = memberKey ? advisorBookSessionHref(memberKey) : "";
    $[13] = memberKey;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const bookUrl = t7;
  let t8;
  if ($[15] !== memberKey || $[16] !== normalized || $[17] !== waiveCode) {
    t8 = memberKey ? advisorBookSessionHref(memberKey, normalized || waiveCode.trim().toLowerCase()) : "";
    $[15] = memberKey;
    $[16] = normalized;
    $[17] = waiveCode;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const complimentaryUrl = t8;
  let t9;
  if ($[19] !== normalized || $[20] !== upsert) {
    t9 = async () => {
      setError(null);
      setSaved(false);
      if (!normalized) {
        setError("Enter a coupon of 3\u201332 letters, numbers, or hyphens.");
        return;
      }
      ;
      try {
        await upsert({
          variables: {
            input: {
              sessionFeeWaiveCode: normalized
            }
          }
        });
        setWaiveCode(normalized);
        setSaved(true);
      } catch (t10) {
        const err = t10;
        setError(cleanErrorMessage(err, "Could not save the complimentary link."));
      }
    };
    $[19] = normalized;
    $[20] = upsert;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const handleSave = t9;
  let t10;
  if ($[22] !== handleSave) {
    t10 = () => void handleSave();
    $[22] = handleSave;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = value => {
      setWaiveCode(value);
      setSaved(false);
    };
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== bookUrl || $[26] !== complimentaryUrl || $[27] !== error || $[28] !== profileUrl || $[29] !== saved || $[30] !== t10 || $[31] !== upsertState.loading || $[32] !== waiveCode || $[33] !== waiveInvalid) {
    t12 = <ProfileLinksEditor bookUrl={bookUrl} complimentaryUrl={complimentaryUrl} error={error} profileUrl={profileUrl} saved={saved} saving={upsertState.loading} waiveCode={waiveCode} waiveInvalid={waiveInvalid} onSave={t10} onWaiveCodeChange={t11} />;
    $[25] = bookUrl;
    $[26] = complimentaryUrl;
    $[27] = error;
    $[28] = profileUrl;
    $[29] = saved;
    $[30] = t10;
    $[31] = upsertState.loading;
    $[32] = waiveCode;
    $[33] = waiveInvalid;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
};
export const ProfileLinksSection = () => {
  const $ = _c(8);
  const paths = useAdvisorsPaths();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fetchPolicy: "network-only"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const profileQuery = useQuery(MY_ADVISOR_PROFILE, t0);
  const profile = profileQuery.data?.myAdvisorProfile;
  const t1 = profileQuery.loading && !profile;
  let t2;
  if ($[1] !== paths || $[2] !== profile) {
    t2 = profile ? <ProfileLinksForm profile={profile} /> : <EmptyState description="Finish the application, then return here to copy your public links." icon={<LuUserRound />} size="sm" title="Create an advisor profile first"><Button asChild={true} variant="cta"><NextLink href={paths.apply}>Apply to advise</NextLink></Button></EmptyState>;
    $[1] = paths;
    $[2] = profile;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== profileQuery.error || $[5] !== t1 || $[6] !== t2) {
    t3 = <AdvisorsQueryState error={profileQuery.error} loading={t1}>{t2}</AdvisorsQueryState>;
    $[4] = profileQuery.error;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};